import {invisiblyApi} from "../api/invisibly-api";
import { APITagType } from "../api/invisibly-api.types";
import {InvisiblyApiResponse} from "../../services/api/api-response.types";
import SurveyService from "../../services/surveys/survey.service";
import { SurveyTemplate, SurveyTemplateJSON } from "./template.types";

const templateEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getTemplates: builder.query<Record<string, SurveyTemplate[]>, null>({
      query: () => ({
        method: 'get',
        url: 'b2b/templates',
        handleErrorGlobally: false,
      }),
      providesTags: [{ type: APITagType.FlowTemplates, id: 'LIST' }],
      transformResponse: (response: InvisiblyApiResponse<SurveyTemplateJSON[]>) => {
        const templates = SurveyService.parseSurveyTemplates(response.item);
        const groupedTemplates = templates.reduce<Record<string, SurveyTemplate[]>>(
          (acc, template) => {
            if (!acc[template.category]) {
              acc[template.category] = [];
            }
            acc[template.category].push(template);
            return acc;
          },
          {}
        );
        return groupedTemplates;
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetTemplatesQuery,
} = templateEndpoints;
